import React, { useState, useCallback } from "react";
import Dropdown from "../../dropdown/dropdown";
import { MilestoneFilterDropdownProps, MILESTONE_FILTER_PARAMS } from "../types";
import MilestoneOption from "./MilestoneOption";
import { useMilestoneData } from "../hooks/useMilestoneData";
import { DROPDOWN_CONFIG, getDropdownSxProps } from "../dropdownStyles";

export const MilestoneFilterDropDown: React.FC<MilestoneFilterDropdownProps> = ({ milestones, setSelectedMilestoneType, setGetParams, getParams, milestoneSpecificCounts }) => {
       const getSelectedMilestone = getParams.get(MILESTONE_FILTER_PARAMS.milestone);

       // Use the custom hook to get all milestone data
       const { arrayOptions, defaultOption } = useMilestoneData({ milestones, milestoneSpecificCounts });

       // Create dropdown options with JSX labels
       const dropdownOptions = arrayOptions.map(option => ({
              ...option,
              label: (
                     <MilestoneOption
                            name={option.label as string}
                            exceptionCount={option.exceptionCount ?? 0}
                            alertsCount={option.alertsCount ?? 0}
                            notesCount={option.notesCount ?? 0}
                            generalCommentsCount={option.generalCommentsCount ?? 0}
                            isDefault={option.value === defaultOption.value}
                            maxWidth={DROPDOWN_CONFIG.maxWidth}
                     />
              )
       }));

       // Find the selected option
       const getOptionByFilter = dropdownOptions.find(
              (item) => item.value === getSelectedMilestone
       );

       const [dropdownOption, setDropdownOption] = useState(getOptionByFilter || dropdownOptions[0]);

       // Handle dropdown change
       const handleDropdownChange = useCallback((item: any) => {
              setSelectedMilestoneType?.(item.value);
              setDropdownOption(item);
              setGetParams((params: URLSearchParams) => {
                     params.set(MILESTONE_FILTER_PARAMS.milestone, item.value);
                     return params;
              });
       }, [setSelectedMilestoneType, setGetParams]);

       return (
              <Dropdown
                     options={dropdownOptions}
                     onChange={handleDropdownChange}
                     placeholder="Select milestone filter"
                     selectedOption={dropdownOption}
                     style={{ width: DROPDOWN_CONFIG.width }}
                     sx={getDropdownSxProps()}
              />
       );
};

export default MilestoneFilterDropDown; 